import { inject, Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { CacheService } from "./cache-service";
import { ReusableService } from "./reusable-services";
import { GigyaService2 } from "./gigya-service2";
import { API_PATHS } from "../constants/api-paths";
import { BaseService } from "./base-service";
import { CACHE_KEYS } from "../constants/cache-keys";
import { SaveCartService } from "../../saved-shopping-cart/saved-shopping-cart-service";
import { VehicleSearchService } from "../../landing-page/vehicle-search/vehicle-search-service";
import { hasCookie } from "../utils/utils";
import { COOKIE_CONSTANTS } from "../constants/cookie";

@Injectable({
  providedIn: "root",
})
export class LogoutService {
  gigyaService2 = inject(GigyaService2);
  reusableService = inject(ReusableService);
  cacheService = inject(CacheService);
  baseService = inject(BaseService);
  savedCartService = inject(SaveCartService);
  vehicleSearchService = inject(VehicleSearchService);

  async logout(): Promise<void> {
    try {
      //Save the active cart id before logout and clearing cache
      const cartId = this.cacheService.getFromCache(CACHE_KEYS.USER.CART_ID);
      await firstValueFrom(this.savedCartService.saveCart(cartId));
    } catch (error) {
      console.log("Saving cart Error: ", error);
    }

    let clearSessionError: any = null;
    try {
      await this.clearSession();
    } catch (error) {
      clearSessionError = error;
      console.log("Clear session Error: ", error);
    }

    try {
      const res: any = await this.gigyaService2.logout();
      if (res?.errorCode === 0) {
        this.reusableService.setUserContextVariable(null);
        this.vehicleSearchService.updateVehicleDetails(null);
        this.cacheService.clearCache();
      }
    } catch (error) {
      console.log("Logout Error: ", error);
      this.vehicleSearchService.updateVehicleDetails(null);
      this.reusableService.setUserContextVariable(null);
      this.cacheService.clearCache();
      throw error;
    }

    if (clearSessionError) {
      throw clearSessionError;
    }
  }

  isLoggedIn(): boolean {
    return hasCookie(COOKIE_CONSTANTS.SRP_SESSION);
  }

  async clearSession(): Promise<void> {
    const uid = this.cacheService.getFromCache(CACHE_KEYS.USER.GIGYA_UID);
    await this.baseService.post(API_PATHS.AUTH.LOGOUT, { action: "logout", UID: uid });
  }
}
